import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ProjectAssignmentService from '../../../Services/ProjectAssignmentsService';
import ExcludedPayEvaluatorsSearchParams from './ExcludedPayEvaluatorsSearchParams';
import AssignmentService from '../../../Services/AssignmentService';
import ExcludedPayEvaluatorsItem from '../../../Domain/ExcludedPayEvaluatorsItem';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ErrorMessage from '../../../Elements/ErrorMessage';

export default class ExcludedPayEvaluatorsAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchItem: new ExcludedPayEvaluatorsSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
    };

    this.startSearch = this.startSearch.bind(this);
    this.renderActionButtons = this.renderActionButtons.bind(this);
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  getAllItemsInTheSearchAreSelected() {
    return this.state.allItemsInTheSearchSetAreSelected;
  }

  getSelectedCount() {
    if (this.getAllItemsInTheSearchAreSelected()) {
      return this.state.numberOfElementsInTheTable;
    }
    return this.state.itemList.filter((u) => u.Selected === true).length;
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  clickOnOkGeneratePayment() {
    ErrorMessage.SetNotification(
      'The assignment payment generation process is running in the background. You will receive a message about the result as soon as it has been finished. '
    );
    // The list's own search item, so "all items in the search" resolves on the server to exactly the rows
    // listed. It carries AssignmentType 'excluded' (ExcludedPayEvaluatorsSearchParams); without it the
    // server matches no list and generates nothing.
    ProjectAssignmentService.GenerateAssignmentPayment(
      [...this.getSelected().map((s) => s.AsId)],
      this.state.searchItem,
      this.state.allItemsInTheSearchSetAreSelected
    )
      .then(() => {
        this.refresh();
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: EPEA56');
      });
  }

  clickOnGenerateAssignmentPayment() {
    ErrorMessage.SetApprove(
      `You are about to generate assignment payment for ${this.getSelectedCount()} assignment(s).`,
      this.clickOnOkGeneratePayment.bind(this)
    );
  }

  renderActionButtons() {
    const disabled = !this.state.itemList.find((il) => il.Selected);
    return (
      <FigmaButtonRow
        buttons={[
          {
            iconName: 'fa-regular fa-check',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnGenerateAssignmentPayment(),
            tooltip: 'Generate Assignment Payment',
            roleKey: 'EvaluatorPayment_GenerateAssignmentPayment_FigmaButtonRowButton',
            disabled,
          },
        ]}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderActionButtons()}
        <TabOfDataTable
          type={ExcludedPayEvaluatorsItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ProjectAssignmentService.GetAssignmentList}
          convertDBItemsFunction={AssignmentService.ConvertDBItemListEvaluator}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          orderBy='ClientName'
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          showSearchStrip={true}
          searchParamsType={ExcludedPayEvaluatorsSearchParams}
          enableUrlPush={false}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Clients, Evaluators, Projects or Apollo Job IDs...'
        />
      </div>
    );
  }
}
